<template>
    <div class="modal-mask">
        <div class="modal-content-container">
            <div class="subrequest-modal-header">
                {{
                    `Análise das quantidades - forn: ${this.salesman.nomeFornecedor}`
                }}
                <span
                    v-on:click="close"
                    class="material-icons subrequest-modal-close-icon"
                    >cancel</span
                >
            </div>
            <div class="subrequest-modal-body">
                <div class="subrequest-modal-body-title">
                    <div style="display: flex">
                        <div>Vendedor: {{ salesman.nomeVendedor }}</div>
                        <span class="rate" v-if="rate"
                            ><i class="fa fa-star" aria-hidden="true"></i> ({{
                                rate
                            }})</span
                        >
                        <a
                            v-if="salesman.usu_telefone"
                            style="margin-left: 1vw; color: black"
                            :href="
                                'https://api.whatsapp.com/send?phone=' +
                                formatNumber(salesman.usu_telefone)
                            "
                            target="_blank"
                            >{{ "Tel:" + phone(salesman.usu_telefone) }}</a
                        >
                    </div>
                    <div class="subrequest-modal-body-title-buttons">
                        <StandardButton
                            class="subrequest-modal-body-mobile-width"
                            :action="close"
                            :iconName="'arrow_back'"
                            :text="'Voltar'"
                        />
                        <StandardButton
                            class="subrequest-modal-body-title-last-button subrequest-modal-body-mobile-width"
                            :action="saveAllAndClose"
                            :iconName="'email'"
                            :text="'Enviar'"
                        />
                    </div>
                </div>
                <div class="subrequest-modal-body-inputs">
                    <div
                        class="subrequest-modal-body-input-product mobile-product-name"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Produto
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ product.descricaoProduto }}
                        </div>
                    </div>
                    <div
                        class="subrequest-modal-body-input-product mobile-product-brand"
                        v-if="salesman.pro_observacao"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Marca
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ salesman.pro_observacao }}
                        </div>
                    </div>
                </div>
                <div
                    class="subrequest-modal-body-input-product"
                    style="width: 100%; margin-bottom: 2vh"
                >
                    <div class="subrequest-modal-body-input-title">
                        Observação
                    </div>
                    <div class="subrequest-modal-body-input-value">
                        {{ this.salesman.observacao }}
                    </div>
                </div>
                <div class="subrequest-modal-body-inputs">
                    <div
                        class="subrequest-modal-body-input-smal"
                        v-if="salesman.embalagem"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Embalagem
                            <i
                                class="far fa-edit"
                                style="
                                    color: var(--primary-color);
                                    cursor: pointer;
                                "
                                @click="open_edit_wrap = true"
                                v-if="!product.possuiPedido"
                            />
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ salesman.embalagem }}
                        </div>
                    </div>
                    <div class="subrequest-modal-body-input-smal">
                        <div class="subrequest-modal-body-input-title">
                            Preço
                            <i
                                class="far fa-handshake"
                                style="
                                    color: var(--primary-color);
                                    cursor: pointer;
                                "
                                @click="open_negotiation_modal = true"
                                v-if="!product.possuiPedido"
                                title="Negociar"
                            />
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ formatPrice(salesman.valor) }}
                        </div>
                    </div>
                    <div
                        class="subrequest-modal-body-input-smal"
                        v-if="product.embalagem || product.unidade_compra"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Unidade de Compra
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{
                                product.flag_generico == 0
                                    ? product.pro_embalagem
                                    : product.unidade_compra
                            }}
                        </div>
                    </div>
                </div>
                <div class="subrequest-modal-body-inputs">
                    <div
                        class="subrequest-modal-body-input-smal"
                        v-if="delivery && delivery.data_entrega"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Data de Entrega
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{
                                (delivery ? delivery.data_entrega : "")
                                    | formatDateOnly
                            }}
                        </div>
                    </div>
                    <div
                        class="subrequest-modal-body-input-smal"
                        v-if="salesman.faturamento_minimo"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Faturamento Mínimo
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ formatPrice(salesman.faturamento_minimo) }}
                        </div>
                    </div>
                    <div
                        class="subrequest-modal-body-input-smal"
                        v-if="delivery && delivery.forma"
                    >
                        <div class="subrequest-modal-body-input-title">
                            Forma de Pagamento
                        </div>
                        <div class="subrequest-modal-body-input-value">
                            {{ delivery ? delivery.forma : "" }}
                        </div>
                    </div>
                </div>
                <cc-loader v-if="is_loading" style="margin-top: 5vh" />
                <div v-else class="subrequest-modal-table-overflow">
                    <div class="subrequest-modal-table-width">
                        <div class="subrequest-modal-table">
                            <div class="subrequest-modal-table-id-width">
                                ID
                            </div>
                            <div class="subrequest-modal-table-company-width">
                                Empresa
                            </div>
                            <div class="subrequest-modal-table-req-width">
                                Req.
                            </div>
                            <div class="subrequest-modal-table-est-width">
                                Est.
                            </div>
                            <div class="subrequest-modal-table-order-width">
                                Qtd Pedido
                            </div>
                            <div
                                class="subrequest-modal-table-total-item-width"
                            >
                                Total Item
                            </div>
                            <div
                                class="subrequest-modal-table-total-order-width"
                            >
                                Total Pedido
                            </div>
                        </div>
                        <div
                            class="subrequest-modal-table-row"
                            v-for="(store, idx) in visibleStores()"
                            v-bind:key="idx"
                            :class="getSpecialBackground(idx)"
                        >
                            <!-- desktop -->
                            <div
                                class="subrequest-modal-table-id-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    ID
                                </div>
                                {{ store.codSolicitacao }}
                            </div>
                            <div
                                class="subrequest-modal-table-company-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Empresa
                                </div>
                                {{ store.descricaoLoja }}
                            </div>
                            <div
                                class="subrequest-modal-table-req-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Req.
                                </div>
                                {{ store.quantidade }}
                            </div>
                            <div
                                class="subrequest-modal-table-est-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Est.
                                </div>
                                {{ store.estoque ? store.estoque : "--" }}
                            </div>
                            <div
                                class="subrequest-modal-table-order-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Pedido
                                </div>
                                <input
                                    class="subrequest-modal-table-order-input"
                                    :class="{
                                        'subrequest-modal-table-order-input-disabled':
                                            isStoreLocked(store),
                                        'subrequest-modal-table-order-input-altered':
                                            store.isAltered,
                                    }"
                                    type="number"
                                    min="0"
                                    step="1"
                                    inputmode="numeric"
                                    pattern="[0-9]*"
                                    :disabled="isStoreLocked(store)"
                                    v-on:keydown="preventNonIntegerQuantity($event) || saveOne($event, store)"
                                    :value="store.quantidadeSugestao"
                                    v-on:input="setIntegerQuantity($event, store, 'quantidadeSugestao')"
                                    :id="'product-amount' + idx"
                                    v-on:keyup="process_event($event, idx)"
                                    v-on:blur="saveIfChanged(store)"
                                    @wheel.prevent
                                />
                            </div>
                            <div
                                class="subrequest-modal-table-total-item-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Total Item
                                </div>
                                {{ formatPrice(calculateAmount(store)) }}
                            </div>
                            <div
                                class="subrequest-modal-table-total-order-width desktop"
                            >
                                <div class="subrequest-modal-mobile-header">
                                    Total Pedido
                                </div>
                                <span :class="{ lower: isLower(store) }">
                                    {{
                                        formatPrice(
                                            calculateTotalPedidoAmount(store)
                                        )
                                    }}
                                </span>
                            </div>

                            <!-- mobile -->
                            <div
                                class="subrequest-modal-mobile-header mobile-table-title"
                            >
                                {{ store.descricaoLoja }}
                            </div>
                            <div class="mobile mobile-table-row">
                                <div class="mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        ID
                                    </div>
                                    {{ store.codSolicitacao }}
                                </div>
                                <div class="mobile-center mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        Req.
                                    </div>
                                    {{ store.quantidade }}
                                </div>
                                <div class="mobile-end mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        Est.
                                    </div>
                                    {{ store.estoque ? store.estoque : "--" }}
                                </div>
                            </div>
                            <div class="mobile mobile-table-row">
                                <div class="mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        Pedido
                                    </div>
                                    <input
                                        class="subrequest-modal-table-order-input"
                                        :class="{
                                            'subrequest-modal-table-order-input-disabled':
                                                isStoreLocked(store),
                                            'subrequest-modal-table-order-input-altered':
                                                store.isAltered,
                                        }"
                                        type="number"
                                        min="0"
                                        step="1"
                                        inputmode="numeric"
                                        pattern="[0-9]*"
                                        :disabled="isStoreLocked(store)"
                                        v-on:keydown="preventNonIntegerQuantity($event) || saveOne($event, store)"
                                        :value="store.quantidadeSugestao"
                                        v-on:input="setIntegerQuantity($event, store, 'quantidadeSugestao')"
                                        :id="'product-amount' + idx"
                                        v-on:keyup="process_event($event, idx)"
                                        v-on:blur="saveIfChanged(store)"
                                        @wheel.prevent
                                    />
                                </div>
                                <div class="mobile-center mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        Total Item
                                    </div>
                                    {{ formatPrice(calculateAmount(store)) }}
                                </div>
                                <div class="mobile-end mobile-colum-size">
                                    <div class="subrequest-modal-mobile-header">
                                        Total Pedido
                                    </div>
                                    <span :class="{ lower: isLower(store) }">
                                        {{
                                            formatPrice(
                                                calculateTotalPedidoAmount(
                                                    store
                                                )
                                            )
                                        }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ProductWrapModal
            v-if="open_edit_wrap"
            :product="product"
            :salesman="salesman"
            @close="update_wrap(product)"
        />
        <NegotiationModal
            @close="reset_negotitation"
            :typing="salesman || {}"
            :product="mapped_product || {}"
            v-if="open_negotiation_modal"
            :quotation_id="$route.params.id"
        />
    </div>
</template>

<script>
import StandardButton from "@/components/ui/buttons/Standard-Button.vue";
import QuotationService from "@/services/QuotationService";
import ProviderService from "@/services/v3/provider.service";
import ErrorHandlerService from "@/services/ErrorHandlerService";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal";
import NegotiationModal from "@/modals/negotiate-offer/negotiate-offer.modal";
import { perm_mixin } from "@/mixins/permission.mixin";
import { mapState } from "vuex";
import currencyPrecision from "@/mixins/currencyPrecision";
import { integerQuantityMixin } from "@/mixins/integer-quantity.mixin";
export default {
    components: {
        ProductWrapModal,
        NegotiationModal,
        StandardButton,
    },
    props: [
        "quotationId",
        "product",
        "salesman",
        "sellers",
        "loj_id",
        "stores_only",
    ],
    mixins: [perm_mixin, currencyPrecision, integerQuantityMixin],
    data() {
        return {
            modal: {
                title: `análise das quantidades - forn: #${this.salesman.nomeFornecedor}`,
                permitted: true,
                submit: this.saveAllAndClose,
                submit_text: "Enviar",
                subtitle:
                    "Defina aqui as quantidades a serem compradas por unidade requisitante",
                icon_title: "fas fa-calculator",
                style: {
                    width: "70%",
                },
            },
            open_negotiation_modal: false,
            open_edit_wrap: false,
            stores: [],
            is_loading: true,
            service: new QuotationService(),
            delivery: {},
            rate: null,
            myStore: undefined,
        };
    },
    methods: {
        phone(text = "") {
            if (!text) {
                text = "";
            }
            if (text.length < 6) {
                return text;
            }

            text = text.toString().replace("+55", "").replace(/\D/g, "");

            let mask = "($1) $2-$3";
            let regex = /^(\d{2})(\d{5})?(\d{4})?/;

            if (text.length > 13) {
                text = text.substring(text.length - 11);
            } else if (text.length == 13) {
                text = text.substring(text.length - 10);
            } else if (text.length == 12) {
                regex = /^(\d{3})(\d{5})?(\d{4})?/;
            } else if (text.length == 11) {
                regex = /^(\d{2})(\d{5})?(\d{4})?/;
            } else if (text.length == 10) {
                regex = /^(\d{2})(\d{4})?(\d{4})?/;
            } else if (text.length == 9) {
                regex = /^(\d{5})?(\d{4})?/;
                mask = "$1-$2";
            } else if (text.length == 8) {
                regex = /^(\d{4})?(\d{4})?/;
                mask = "$1-$2";
            } else {
                regex = /^(\d{2})?(\d{1,})?/;
                mask = "($1) $2";
            }

            return text.replace(regex, mask);
        },
        formatNumber(number) {
            if (!number) return null;
            number = number
                .replace("+", "")
                .replace("(", "")
                .replace(")", "")
                .replace("-", "");
            if (number[0] + "" + number[1] != "55") number = "55" + number;
            return number;
        },
        process_event(e, index) {
            if (e.key == "ArrowDown") {
                e.preventDefault();
                let element = document.getElementById(
                    "product-amount" + (index + 1)
                );
                if (!element) return;
                if (
                    element.className.includes(
                        "subrequest-modal-table-order-input-disabled"
                    )
                )
                    this.process_event(e, index + 1);
                else {
                    element.focus();
                    element.select();
                }
            } else if (e.key == "ArrowUp") {
                e.preventDefault();
                let element = document.getElementById(
                    "product-amount" + (index - 1)
                );
                if (!element) return;
                if (
                    element.className.includes(
                        "subrequest-modal-table-order-input-disabled"
                    )
                )
                    this.process_event(e, index - 1);
                else {
                    element.focus();
                    element.select();
                }
            }
        },
        is_focused(idx, product) {
            let inputs = this.$refs["product-amount"];
            this.stores.forEach((p) => (p.focused = false));
            if (inputs && document.activeElement == inputs[idx]) {
                this.$set(product, "focused", true);
                this.$forceUpdate();
            }
        },
        reset_negotitation(reload, price, obs) {
            if (reload) {
                this.salesman.observacao = obs;
                this.salesman.valor = price;
                this.$emit("load_products");
            }
            this.open_negotiation_modal = false;
            this.$forceUpdate();
        },
        update_wrap(product) {
            this.open_edit_wrap = false;
            this.reloadProviders();
        },
        visibleStores() {
            let resp = [];
            this.stores.forEach((s) => {
                if (this.myStore && this.myStore == s.codLoja) resp = [s];
                if (
                    !this.myStore &&
                    s.loj_excluido != "1" &&
                    (this.loj_id == undefined || s.codLoja == this.loj_id)
                ) {
                    resp.push(s);
                }
            });
            return resp;
        },
        getDelivery() {
            let delivery = this.sellers
                .filter((s) => s.fornecedores && s.fornecedores.length > 0)
                .map((s) => {
                    let providers = s.fornecedores.filter(
                        (f) => f.idFornecedor == this.salesman.idFornecedor
                    );
                    return providers[0];
                })
                .filter((s) => s != undefined);
            return delivery && delivery[0] ? delivery[0].entrega : {};
        },
        getProvider(store) {
            let storeData = this.sellers.filter(
                (s) => s.loj_id == store.codLoja
            )[0];
            let provider = storeData.fornecedores.filter(
                (p) => p.idFornecedor == store.idFornecedor
            )[0];
            return provider;
        },
        isLower(store) {
            return (
                this.calculateTotalPedidoAmount(store) > 0 &&
                this.calculateTotalPedidoAmount(store) <
                    this.salesman.usu_fatura_min
            );
        },
        calculateAmount(store) {
            let result = this.salesman.valor * store.quantidadeSugestao;
            return this.product.flag_generico == 0 &&
                !this.product.pro_principal &&
                this.user.request_type != 1
                ? parseFloat(this.product.qtd_embalagem) * result
                : result;
        },
        calculateTotalPedidoAmount(store) {
            let total = store.total || 0;
            let result = this.salesman.valor * store.old_value;
            result =
                this.product.flag_generico == 0 &&
                !this.product.pro_principal &&
                this.user.request_type != 1
                    ? parseFloat(this.product.qtd_embalagem) * result
                    : result;
            return total - result + this.calculateAmount(store);
        },
        isStoreLocked(store) {
            return store.vendedorPossuiPedido > 0;
        },
        saveIfChanged(store) {
            if (this.isStoreLocked(store)) return;
            const quantity = this.normalizeIntegerQuantity(store.quantidadeSugestao);
            const lastSaved =
                store.saved_value !== undefined ? store.saved_value : store.old_value;
            if (quantity === lastSaved) return;
            this.$set(store, "is_loading", true);
            this.save(store, () => {
                this.$set(store, "is_loading", false);
                this.$set(store, "saved", true);
                this.$set(store, "isAltered", quantity !== store.old_value);
            });
        },
        saveOne(e, store) {
            if (this.isStoreLocked(store)) return;
            this.$forceUpdate();
            let key = getKey(e);

            function getKey(e) {
                if (e.key) return e.key;
                let keyFromCode = String.fromCharCode(e.keyCode);
                if (keyFromCode) return keyFromCode;
                // add here the tricky keys that you use in your app
                if (e.keyCode === 13) return "Enter";
                // etc
            }

            if (key == "Enter" || key == "ArrowDown" || key == "ArrowUp") {
                e.preventDefault();
                this.saveIfChanged(store);
            }
        },
        reloadProviders() {
            this.getStores();
            this.$emit("loadProviders", this.salesman);
        },
        close() {
            this.$emit("close", this.salesman);
        },
        save(store, callback, onError) {
            const quantity = this.normalizeIntegerQuantity(store.quantidadeSugestao);
            this.$set(store, "quantidadeSugestao", quantity);
            this.$set(store, "saved_value", quantity);
            this.service
                .sendQuantidade({
                    numerocotacao: this.$route.params.id,
                    quantidade: quantity,
                    vendedor: this.salesman.idVendedor,
                    produto: store.codProduto,
                    loja: store.codLoja,
                })
                .then((response) => response.data)
                .then(callback)
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                    if (onError) onError(error);
                });
        },
        getSpecialBackground(idx) {
            if (idx % 2 != 0) return "page-table-line-special";
        },
        saveAllAndClose() {
            let storesToSave = this.stores.filter(
                (s) => !this.isStoreLocked(s)
            );
            if (storesToSave.length === 0) {
                this.close();
                return;
            }
            this.is_loading = true;
            let saved = 0;
            const done = () => {
                saved++;
                if (saved == storesToSave.length) {
                    this.reloadProviders();
                    this.close();
                }
            };
            storesToSave.forEach((store) => {
                this.$set(
                    store,
                    "quantidadeSugestao",
                    this.normalizeIntegerQuantity(store.quantidadeSugestao)
                );
                this.save(store, done, done);
            });
        },
        load_reviews() {
            // Media das avaliacoes do vendedor; sem avaliacao a estrela some.
            new ProviderService()
                .getReview(this.salesman.idVendedor)
                .then((response) => {
                    this.rate = response.data.average_rating;
                })
                .catch(() => {
                    this.rate = null;
                });
        },
        getStores() {
            this.is_loading = this.stores.length === 0;
            var quotationService = new QuotationService();
            quotationService
                .getLojasQuantidade(
                    this.salesman.pro_id,
                    this.quotationId,
                    this.salesman.idVendedor
                )
                .then((response) => response.data)
                .then((data) => {
                    this.stores = data.produtos;
                    this.is_loading = false;
                    this.stores.forEach((s) => {
                        this.sellers.forEach((element) => {
                            if (s.descricaoLoja == element.loj_descricao)
                                s.loj_excluido = element.loj_excluido;
                        });
                        if (s.quantidadeSugestao == null) {
                            s.quantidadeSugestao = this.normalizeIntegerQuantity(
                                s.quantidade
                            );
                        } else {
                            s.quantidadeSugestao = this.normalizeIntegerQuantity(
                                s.quantidadeSugestao
                            );
                        }
                        s.old_value = s.quantidadeSugestao;
                    });
                })
                .catch((error) => {
                    ErrorHandlerService.handle(error, this.$store);
                });
        },
        formatPrice(value) {
            return this.checkPrecisionValue(value);
        },
    },
    computed: {
        ...mapState(["user"]),
        mapped_product: function () {
            return {
                produtoDescricao: this.product.descricaoProduto,
                ultimaCompra: this.product.last_purchase?.valor,
                pro_observacao: this.salesman.pro_observacao,
                observacao: this.salesman.observacao,
                generico: this.product.flag_generico,
            };
        },
    },
    mounted() {
        this.delivery = this.getDelivery(this.sellers[0]);
        this.getStores();
        this.load_reviews();
        this.product.idProduto = this.product.prod_id;
        this.perms.forEach((element) => {
            if (element.resource == "MY_COMPANY" && element.action == "READ") {
                this.myStore = this.user.store_id;
            }
        });

        // hide scroll body
        document.querySelector("body").style.overflow = "hidden";
    },
    destroyed() {
        document.querySelector("body").style.overflow = "auto";
    },
};
</script>

<style lang="scss" scoped>
@import "./product-sub-requests.modal";
</style>
